const WorkflowLoader = () => {
    return (
        <div className="loading_wf_cont">
            <div className="loading_wf_cont_inner">
                <div className="loading_wf_item fade-in"></div>
                <div className="loading_wf_item fade-in"></div>
            </div>
            <div className="loading_wf_cont_inner_btn_cont fade-in"></div>
            <div className="loading_wf_cont_footer">
                <div className="loading_wf_cont_footer_btns fade-in"></div>
                <div className="loading_wf_cont_footer_map fade-in"></div>
            </div>
        </div>
    )
}

export default WorkflowLoader